import {computed, type ComputedRef} from 'vue';
import {createError} from '#imports';
import {shouldThrowMissingResource} from '~/utils/listingPage';
import type {PrismicDocumentResult} from './usePrismicDocument';

export function useResolvePrismicDocument<T>(
    data: {value: PrismicDocumentResult<T> | null | undefined},
    error: {value: unknown},
): ComputedRef<T | null> {
    const redirected = data.value?.redirected === true;
    if (shouldThrowMissingResource(data.value?.document, error.value, redirected)) {
        throw createError({
            statusCode: 404,
            statusMessage: 'Page not found',
            fatal: true,
        });
    }
    return computed(() => data.value?.document ?? null);
}
